import types from './types';
import axios from 'axios';
import { appOperations } from '../../../../../App/store';
import { MEDIA_USAGE_TYPE } from '../../CreatePageConstants';
import { trackEvent, AnalyticsConstants } from '../../../../../utilities/analyticsUtilities';
import { executeCarefully } from '../../../../../utilities/basicUtilities';
import MediaPickersConstants from '../MediaPickersConstants';

// DUMB ACTIONS

const setProperty = (key, value) => {
    return {
        type: types.SET_PROPERTY,
        key: key,
        value: value
    }
}

const setLogoStockImages = (images, pageNumber, allItemsCount) => {
    return {
        type: types.SET_LOGO_STOCK_IMAGES,
        images,
        pageNumber,
        allItemsCount
    }
}

const clearLogoStockImages = () => {
    return {
        type: types.CLEAR_LOGO_STOCK_IMAGES
    }
}

const setImageElementStockImages = (images, pageNumber, allItemsCount) => {
    return {
        type: types.SET_IMAGE_ELEMENT_STOCK_IMAGES,
        images,
        pageNumber,
        allItemsCount
    }
}
const setImageStockImages = setImageElementStockImages;

const clearImageElementStockImages = () => {
    return {
        type: types.CLEAR_IMAGE_ELEMENT_STOCK_IMAGES
    }
}
const clearImageStockImages = clearImageElementStockImages;

const setBackgroundStockImages = (images, pageNumber, allItemsCount) => {
    return {
        type: types.SET_BACKGROUND_STOCK_IMAGES,
        images,
        pageNumber,
        allItemsCount
    }
}

const clearBackgroundStockImages = () => {
    return {
        type: types.CLEAR_BACKGROUND_STOCK_IMAGES
    }
}

const setBackgroundCatalogVideos = (videos, pageNumber, allItemsCount) => {
    return {
        type: types.SET_BACKGROUND_CATALOG_VIDEOS,
        videos,
        pageNumber,
        allItemsCount
    }
}

const clearBackgroundCatalogVideos = () => {
    return {
        type: types.CLEAR_BACKGROUND_CATALOG_VIDEOS
    }
}

const setBackgroundStockVideos = (videos, pageNumber, allItemsCount) => {
    return {
        type: types.SET_BACKGROUND_STOCK_VIDEOS,
        videos,
        pageNumber,
        allItemsCount
    }
}

const clearBackgroundStockVideos = () => {
    return {
        type: types.CLEAR_BACKGROUND_STOCK_VIDEOS
    }
}

const setUserAssets = (assets) => {
    return {
        type: types.SET_USER_ASSETS,
        logoImages: assets.logoImages,
        backgroundImages: assets.backgroundImages,
        backgroundVideos: assets.backgroundVideos
    }
}

const setUserLogoAssets = (logoAssets, pageNumber, count) => {
    return {
        type: types.SET_USER_LOGO_ASSETS,
        logoAssets,
        pageNumber,
        count
    }
}

const setUserImageElementAssets = (imageAssets, pageNumber, count) => {
    return {
        type: types.SET_USER_IMAGE_ELEMENT_ASSETS,
        assets: imageAssets,
        pageNumber,
        count
    }
}
const setUserImageAssets = setUserImageElementAssets;

const setUserBackgroundAssets = (backgroundAssets, pageNumber, count) => {
    return {
        type: types.SET_USER_BACKGROUND_ASSETS,
        backgroundAssets,
        pageNumber,
        count
    }
}

const addNewLogoAsset = (asset) => {
    return {
        type: types.ADD_USER_LOGO_ASSET,
        asset
    }
}

const addNewImageElementAsset = (asset) => {
    return {
        type: types.ADD_USER_IMAGE_ELEMENT_ASSET,
        asset
    }
}
const addNewImageAsset = addNewImageElementAsset;

const addNewBackgroundAsset = (asset) => {
    return {
        type: types.ADD_USER_BACKGROUND_ASSET,
        asset
    }
}

const clearUserAssets = () => {
    return {
        type: types.CLEAR_USER_ASSETS
    }
}

const removeUserAsset = (id, usageType) => {
    return {
        type: types.REMOVE_USER_ASSET,
        id,
        usageType
    }
}

const showImageCropper = (data, format, mediaSourceType, mediaUsageType, mediaResourceId, mediaResourceUrl, particleIndex) => {
    return {
        type: types.SHOW_IMAGE_CROPPER,
        data,
        format,
        mediaSourceType,
        mediaUsageType,
        mediaResourceId,
        mediaResourceUrl,
        particleIndex
    }
}

const hideImageCropper = () => {
    return {
        type: types.HIDE_IMAGE_CROPPER
    }
}

const showCatalogVideoPreview = (catalogVideoId, isPremium, urls) => {
    return {
        type: types.SHOW_CATALOG_VIDEO_PREVIEW,
        catalogVideoId,
        isPremium,
        urls
    }
}

const hideCatalogVideoPreview = () => {
    return {
        type: types.HIDE_CATALOG_VIDEO_PREVIEW
    }
}

const showStockVideoPreview = (stockVideoId, isPremium, urls) => {
    return {
        type: types.SHOW_STOCK_VIDEO_PREVIEW,
        stockVideoId,
        isPremium,
        urls 
    }
}

const hideStockVideoPreview = () => {
    return {
        type: types.HIDE_STOCK_VIDEO_PREVIEW
    }
}

const openPremiumVideosDialogAction = (videoUrl, onGoBack) => {
    return {
        type: types.OPEN_PREMIUM_VIDEOS_DIALOG,
        videoUrl,
        onGoBack
    }
}

const closePremiumVideosDialog = () => {
    return {
        type: types.CLOSE_PREMIUM_VIDEOS_DIALOG
    }
}

// SMART OPERATIONS

// Opens the picker of the image elements. A target index replaces the picture of that element; the
// default, no index at all, adds the picked picture to the panel as a new element.
const openImageElementPicker = (targetIndex = null) => {
    return (dispatch) => {
        dispatch(setProperty('imageElementPickerTargetIndex', targetIndex));
        dispatch(setProperty('imageElementMediaPickerOpen', true));
    }
}
const openImagePicker = openImageElementPicker;

const searchLogoStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback, shouldTrack = true) => {
    return (dispatch, getState) => {
        const state = getState();
        const fallbackKeyword = state?.mediaPicker?.logoStockImagesDefaultKeyword || 'wallpaper';
        const searchPhrase = (!keywords) ? fallbackKeyword : keywords;
        const count = itemsPerPage || MediaPickersConstants.LOGO_STOCK_IMAGES_PER_PAGE || 11;

        let params = `keywords=${searchPhrase}&orientation=${orientation}&pageNumber=${pageNumber}&itemsPerPage=${count}&mediaUsageType=${MEDIA_USAGE_TYPE.LOGO}`;
        let url = `api/StockMedia/FindImages?${params}`;

        axios.get(url).then(response => {
            dispatch(setLogoStockImages(response.data.items, pageNumber, response.data.total));
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => searchLogoStockImages(searchPhrase, orientation, pageNumber, itemsPerPage, callback, shouldTrack), 'Images not found.'));
        }).finally(() => {
            executeCarefully(callback);
        });

        if (shouldTrack && keywords) {
            trackImagesSearchEvent(searchPhrase, pageNumber, 'logo');
        }
    }
}

const loadDefaultLogoStockImages = () => {
    return (dispatch, getState) => {
        const state = getState();
        const logoStockImages = state.mediaPicker.logoStockImages;
        
        if (!logoStockImages.length) {
            dispatch(setProperty('logoStockImagesInitializing', true));

            const defaultKeywords = MediaPickersConstants.DEFAULT_STOCK_IMAGE_KEYWORDS;
            const selectedKeyword = defaultKeywords[Math.floor(Math.random() * defaultKeywords.length)];
            
            dispatch(setProperty('logoStockImagesDefaultKeyword', selectedKeyword));

            dispatch(searchLogoStockImages(selectedKeyword, state.mediaPicker.logoStockImagesOrientation, 1, MediaPickersConstants.LOGO_STOCK_IMAGES_PER_PAGE, () => {
                dispatch(setProperty('logoStockImagesInitializing', false));
            }, false));
        }
    }
}

const searchImageElementStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback, shouldTrack = true) => {
    return (dispatch, getState) => {
        const state = getState();
        const fallbackKeyword = state?.mediaPicker?.imageElementStockImagesDefaultKeyword || state?.mediaPicker?.imageStockImagesDefaultKeyword || 'wallpaper';
        const searchPhrase = (!keywords) ? fallbackKeyword : keywords;

        let params = `keywords=${searchPhrase}&orientation=${orientation}&pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}&mediaUsageType=${MEDIA_USAGE_TYPE.IMAGE_ELEMENT}`;
        let url = `api/StockMedia/FindImages?${params}`;

        axios.get(url).then(response => {
            dispatch(setImageElementStockImages(response.data.items, pageNumber, response.data.total));
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => searchImageElementStockImages(searchPhrase, orientation, pageNumber, itemsPerPage, callback, shouldTrack), 'Images not found.'));
        }).finally(() => {
            executeCarefully(callback);
        });

        if (shouldTrack && keywords) {
            trackImagesSearchEvent(searchPhrase, pageNumber, 'image-element');
        }
    }
}
const searchImageStockImages = searchImageElementStockImages;

const loadDefaultImageElementStockImages = () => {
    return (dispatch, getState) => {
        const state = getState();
        const imageStockImages = state.mediaPicker.imageElementStockImages || state.mediaPicker.imageStockImages;

        if (!imageStockImages || !imageStockImages.length) {
            dispatch(setProperty('imageElementStockImagesInitializing', true));

            const defaultKeywords = MediaPickersConstants.DEFAULT_STOCK_IMAGE_KEYWORDS;
            const selectedKeyword = defaultKeywords[Math.floor(Math.random() * defaultKeywords.length)];

            dispatch(setProperty('imageElementStockImagesDefaultKeyword', selectedKeyword));

            const orientation = state.mediaPicker.imageElementStockImagesOrientation || state.mediaPicker.imageStockImagesOrientation;
            dispatch(searchImageElementStockImages(selectedKeyword, orientation, 1, MediaPickersConstants.STOCK_IMAGES_PER_PAGE, () => {
                dispatch(setProperty('imageElementStockImagesInitializing', false));
            }, false));
        }
    }
}
const loadDefaultImageStockImages = loadDefaultImageElementStockImages;

const searchBackgroundStockImages = (keywords, orientation, pageNumber, itemsPerPage, callback, shouldTrack = true) => {
    return (dispatch, getState) => {
        const state = getState();
        const fallbackKeyword = state?.mediaPicker?.backgroundStockImagesDefaultKeyword || 'wallpaper';
        const searchPhrase = (!keywords) ? fallbackKeyword : keywords;

        let params = `keywords=${searchPhrase}&orientation=${orientation}&pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}&mediaUsageType=${MEDIA_USAGE_TYPE.BACKGROUND}`;
        let url = `api/StockMedia/FindImages?${params}`;

        axios.get(url).then(response => {
            dispatch(setBackgroundStockImages(response.data.items, pageNumber, response.data.total));
        }).catch(error => { 
            dispatch(appOperations.failRequest(error, () => searchBackgroundStockImages(searchPhrase, orientation, pageNumber, itemsPerPage, callback, shouldTrack), 'Images not found.'));
        }).finally(() => {
            executeCarefully(callback);
        });

        if (shouldTrack && keywords) {
            trackImagesSearchEvent(searchPhrase, pageNumber, 'background');
        }
    }
}

const loadDefaultBackgroundStockImages = () => {
    return (dispatch, getState) => {
        const state = getState();
        const backgroundStockImages = state.mediaPicker.backgroundStockImages;
        
        if (!backgroundStockImages.length) {
            dispatch(setProperty('backgroundStockImagesInitializing', true));

            const defaultKeywords = MediaPickersConstants.DEFAULT_STOCK_IMAGE_KEYWORDS;
            const selectedKeyword = defaultKeywords[Math.floor(Math.random() * defaultKeywords.length)];
            
            dispatch(setProperty('backgroundStockImagesDefaultKeyword', selectedKeyword));

            dispatch(searchBackgroundStockImages(selectedKeyword, state.mediaPicker.backgroundStockImagesOrientation, 1, MediaPickersConstants.BACKGROUND_STOCK_IMAGES_PER_PAGE, () => {
                dispatch(setProperty('backgroundStockImagesInitializing', false));
            }, false));
        }
    }
}

const searchBackgroundStockVideos = (keywords, orientation, pageNumber, itemsPerPage, callback) => {
    return (dispatch) => {
        const searchPhrase = (!keywords) ? 'loop' : keywords;
        let params = `keywords=${searchPhrase}&orientation=${orientation}&pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}&mediaUsageType=${MEDIA_USAGE_TYPE.BACKGROUND}`;

        axios.get(`api/StockMedia/FindVideos?${params}`).then(response => {
            dispatch(setBackgroundStockVideos(response.data.items, pageNumber, response.data.total));
        }).catch(error => { 
            dispatch(appOperations.failRequest(error, () => searchBackgroundStockVideos(searchPhrase, pageNumber, itemsPerPage, callback), 'Videos not found.'));
        }).finally(() => {
            executeCarefully(callback);
        });
    }
}

const loadUserLogoAssets = (pageNumber, itemsPerPage) => {
    return async (dispatch, getState) => {
        const state = getState();
        const initializedLogoAssets = state.mediaPicker.logoAssetsCount;
        const count = itemsPerPage || MediaPickersConstants.LOGO_ASSETS_PER_PAGE || 11;

        try {
            if (!initializedLogoAssets)
                dispatch(setProperty('userAssetsInitializing', true));

            dispatch(setProperty('logoAssetsLoading', true));

            const response = await axios.get(`api/Assets/GetUserLogoAssets`, {
                params: {
                    pageNumber,
                    itemsPerPage: count
                }
            });

            dispatch(setUserLogoAssets(response.data.items, response.data.pageNumber, response.data.total));
        } catch (error) {
            dispatch(appOperations.failRequest(error, () => loadUserLogoAssets(pageNumber, itemsPerPage), 'Assets not found.'));
        } finally {
            dispatch(setProperty('logoAssetsLoading', false));

            if (!initializedLogoAssets)
                dispatch(setProperty('userAssetsInitializing', false));
        }
    };
};

const loadUserImageElementAssets = (pageNumber, itemsPerPage) => {
    return async (dispatch, getState) => {
        const state = getState();
        const initializedImageAssets = state.mediaPicker.imageElementAssetsCount || state.mediaPicker.imageAssetsCount;

        try {
            if (!initializedImageAssets)
                dispatch(setProperty('userAssetsInitializing', true));

            dispatch(setProperty('imageElementAssetsLoading', true));

            const response = await axios.get(`api/Assets/GetUserImageElementAssets`, {
                params: {
                    pageNumber,
                    itemsPerPage
                }
            });

            dispatch(setUserImageElementAssets(response.data.items, response.data.pageNumber, response.data.total));
        } catch (error) {
            dispatch(appOperations.failRequest(error, () => loadUserImageElementAssets(pageNumber, itemsPerPage), 'Assets not found.'));
        } finally {
            dispatch(setProperty('imageElementAssetsLoading', false));

            if (!initializedImageAssets)
                dispatch(setProperty('userAssetsInitializing', false));
        }
    };
};
const loadUserImageAssets = loadUserImageElementAssets;

const loadUserBackgroundAssets = (pageNumber, itemsPerPage) => {
    return async  (dispatch, getState) => {
        const state = getState();
        const initializedBackgroundAssets = state.mediaPicker.backgroundAssetsCount;
        
        try {
            if (!initializedBackgroundAssets)
                dispatch(setProperty('userAssetsInitializing', true));

            dispatch(setProperty('backgroundAssetsLoading', true));

            const response = await axios.get(`api/Assets/GetUserBackgroundAssets`, {
                params: {
                    pageNumber,
                    itemsPerPage
                }
            });
            const backgroundAssets = [...response.data.videoAssets, ...response.data.imageAssets];

            if (backgroundAssets && backgroundAssets.length) {
                backgroundAssets.sort((a, b) => (new Date(a.createdTime) < new Date(b.createdTime)) ? 1 : ((new Date(b.createdTime) < new Date(a.createdTime)) ? -1 : 0));
            }

            dispatch(setUserBackgroundAssets(backgroundAssets, response.data.pageNumber, response.data.total));
        } catch (error) {
            dispatch(appOperations.failRequest(error, () => loadUserBackgroundAssets(pageNumber, itemsPerPage), 'Assets not found.'));
        } finally {
            dispatch(setProperty('backgroundAssetsLoading', false));

            if (!initializedBackgroundAssets)
                dispatch(setProperty('userAssetsInitializing', false));
        }
    };
};

const loadBackgroundCatalogVideos = (pageNumber, itemsPerPage, callback) => {
    return (dispatch) => {
        const endpoint = `api/Assets/GetCatalogVideos?pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}`;

        axios.get(endpoint).then(response => {
            dispatch(setBackgroundCatalogVideos(response.data.items, response.data.pageNumber, response.data.total));
        }).catch(error => {
            dispatch(appOperations.failRequest(error, () => loadBackgroundCatalogVideos(pageNumber, itemsPerPage, callback), 'Videos not found.'));
        }).finally(() => {
            executeCarefully(callback);
        });
    }
}

const loadNewAsset = (assetId, mediaResourceType, mediaUsageType) => {
    return async (dispatch) => {
        try {
            const params = {
                assetId,
                mediaResourceType,
                mediaUsageType,
            };

            const response = await axios.get(`api/Assets/GetUserAsset`, { params: params });

            if (response.data) {
                if (mediaUsageType == MEDIA_USAGE_TYPE.BACKGROUND)
                    dispatch(addNewBackgroundAsset(response.data));

                if (mediaUsageType == MEDIA_USAGE_TYPE.LOGO)
                    dispatch(addNewLogoAsset(response.data));

                if (mediaUsageType == MEDIA_USAGE_TYPE.IMAGE_ELEMENT)
                    dispatch(addNewImageAsset(response.data));
            }
        } catch (error) {

        } finally {

        }
    }
}

const loadInitialBackgroundCatalogVideos = () => {
    return (dispatch, getState) => {
        const state = getState();
        const backgroundCatalogVideos = state.mediaPicker.backgroundCatalogVideos;
        
        if (!backgroundCatalogVideos.length) {
            dispatch(setProperty('backgroundCatalogVideosInitializing', true));

            dispatch(loadBackgroundCatalogVideos(1, MediaPickersConstants.BACKGROUND_CATALOG_VIDEOS_PER_PAGE, () => {
                dispatch(setProperty('backgroundCatalogVideosInitializing', false));
            }));
        }
    }
}

const setLogoStockImagesOrientation = (orientation) => {
    return dispatch => {
        dispatch(setProperty('logoStockImagesOrientation', orientation));

        trackEvent('Set Logo Orientation', {
            orientation: orientation,
        });
    }
}

const setBackgroundStockImagesOrientation = (orientation) => {
    return dispatch => {
        dispatch(setProperty('backgroundStockImagesOrientation', orientation));

        trackEvent('Set Background Orientation', {
            orientation: orientation,
        });
    }
}

const setBackgroundStockVideosOrientation = (orientation) => {
    return dispatch => {
        dispatch(setProperty('setBackgroundStockVideosOrientation', orientation));

        trackEvent('Set Background Orientation', {
            orientation: orientation,
        });
    }
}


const setImageElementStockImagesOrientation = (orientation) => {
    return dispatch => {
        dispatch(setProperty('imageElementStockImagesOrientation', orientation));

        trackEvent('Set Image Orientation', {
            orientation: orientation,
        });
    }
}
const setImageStockImagesOrientation = setImageElementStockImagesOrientation;

const openPremiumVideosDialog = (videoUrl, onGoBack, location) => {
    return (dispatch) => {
        dispatch(openPremiumVideosDialogAction(videoUrl, onGoBack));

        trackEvent('Opened Premium Videos Dialog', {
            category: AnalyticsConstants.ACQUISITION_CATEGORY,
            location: location,
        });
    }
}

export default {
    setProperty,
    removeUserAsset,
    setLogoStockImages,
    clearLogoStockImages,
    setImageElementStockImages,
    clearImageElementStockImages,
    setImageStockImages,
    clearImageStockImages,
    setBackgroundStockImages,
    clearBackgroundStockImages,
    setBackgroundCatalogVideos,
    setBackgroundStockVideos,
    clearBackgroundStockVideos,
    clearBackgroundCatalogVideos,
    setUserAssets,
    clearUserAssets,
    searchLogoStockImages,
    searchImageElementStockImages,
    searchImageStockImages,
    searchBackgroundStockVideos,
    searchBackgroundStockImages,
    showImageCropper,
    hideImageCropper,
    loadDefaultLogoStockImages,
    loadDefaultImageElementStockImages,
    loadDefaultImageStockImages,
    addNewImageElementAsset,
    addNewImageAsset,
    loadDefaultBackgroundStockImages,
    loadUserLogoAssets,
    loadUserImageElementAssets,
    loadUserImageAssets,
    setUserLogoAssets,
    setUserImageElementAssets,
    setUserImageAssets,
    addNewLogoAsset,
    loadNewAsset,
    addNewBackgroundAsset,
    loadUserBackgroundAssets,
    loadBackgroundCatalogVideos,
    showCatalogVideoPreview,
    hideCatalogVideoPreview,
    showStockVideoPreview,
    hideStockVideoPreview,
    setLogoStockImagesOrientation,
    setImageElementStockImagesOrientation,
    setImageStockImagesOrientation,
    setBackgroundStockImagesOrientation,
    setBackgroundStockVideosOrientation,
    loadInitialBackgroundCatalogVideos,
    openPremiumVideosDialog,
    closePremiumVideosDialog,
    openImageElementPicker,
    openImagePicker
};

// HELPERS

const trackImagesSearchEvent = (keywords, pageNumber, destination) => {
    trackEvent('Searched Images', {
        category: AnalyticsConstants.VIDEO_CATEGORY,
        keywords: keywords,
        pageNumber: pageNumber,
        destination: destination,
    });
}
